import { useContext } from "react";
import { useTranslation } from "react-i18next";
import * as Helpers from "../../src/services/Helpers";
import { ProviderContext } from "../ApplicationState";

export const useTranslations = () => {
    const { t } = useTranslation();
    const { providerState } = useContext(ProviderContext);

    const displayLabel = () => {
        const optionLabel = Helpers.getDisplayLabel(providerState)
        return t(optionLabel)
    }

    const widgetItemName = (name: string) => {
        return t(name)
    }

    const pieChartVitalName = (name: string) => {
        return t(name)
    }

    return {
        Signout: t("Signout"),
        Welcome: t("Welcome"),
        Loggedinas: t("Logged in as"),
        MedlineHealth: t("Medline Health"),
        Sessiontimedout: t('Uh-oh! Your session has timed out'),
        Sessiontoolong: t("It seems you took a bit too long."),
        SessionRefresh: t("Refresh the page to continue working or you will be logged out in"),
        SessionSeconds: t("seconds."),
        Refresh: t("Refresh"),
        Edit: t("Edit"),
        Selectaprovider: t("Select a provider"),
        ChangeProvider: t("Change Provider"),
        Menu: t("Menu"),
        Home: t("Home"),
        Providers: t("Providers"),
        SystemUsers: t("System Users"),
        PatientsGroup: t("Patients Group"),
        Threshold: t("Threshold"),
        ScheduleNotifications: t("Schedule Notifications"),
        Survey: t("Survey"),
        ReviewSurvey: t("Review Survey"),
        Patients: t("Patients"),
        Users: t("Users"),
        Members: t("Members"),
        ContactUs: t("Contact Us"),
        BillingReport: t("Billing Report"),
        HangfireDashboard: t("Hangfire Dashboard"),
        FileManager: t("File Manager"),
        ADDEDIT: t("ADD/EDIT"),
        SortbyASC: t("Sort by ASC"),
        Filter: t("Filter"),
        Hidecolumn: t("Hide column"),
        Managecolumns: t("Manage columns"),
        SAVE: t("SAVE"),
        MonitorRequest: t("Monitor Request"),
        searchbyname: t("search by name, etc"),
        Review: t("Review"),
        UserDetail: t("User Detail"),
        Confirm: t("Confirm"),
        Deny: t("Deny"),
        Close: t("Close"),
        PatientName: t("Patient Name"),
        Username: t("Username"),
        DateTime: t("Date/Time"),
        Acknowledge: t("Acknowledge"),
        SortbyDESC: t("Sort by DESC"),
        Vitals: t("Vitals"),
        PatientList: t("Patient List"),
        Name: t("Name"),
        Phone: t("Phone"),
        Created: t("Created"),
        Role: t("Role"),
        Action: t("Action"),
        Search: t("Search"),
        Status: t("Status"),
        ManageColumns: t("Manage columns."),
        Rowperpage: t("Row per page"),
        Latest10Readings: t("Latest 10 Readings"),
        Measurementtype: t("Measurement type"),
        Value: t("Value"),
        Date: t("Date:"),
        RewardProgram: t("Reward Program"),
        Membername: t("Member name"),
        MemberID: t("Member ID"),
        ActivationDate: t("Activation Date"),
        TotalNumberofDaysActive: t("Total Number of Days Active"),
        DaysofActiveSinceStartDate: t("Days of Active Since Start Date"),
        Graphs: t("Graphs"),
        Top5GoalsAchiever: t("Top 5 Goals Achiever"),
        GoalsAchieved: t("Goals Achieved"),
        ManualVsAutomated: t("Manual Vs Automated"),
        Automated: t("Automated"),
        ManualVsAutomatedlast1year: t("Manual Vs Automated (last 1 year)"),
        BloodGlucose: t("Blood Glucose"),
        BloodPressure: t("Blood Pressure"),
        HeartRate: t("Heart Rate"),
        OxygenSaturation: t("Oxygen Saturation"),
        Temperature: t("Temperature"),
        Weight: t("Weight"),
        ScheduleMessages: t("Schedule Messages"),
        Title: t("Title"),
        Startdate: t("Start Date"),
        ResponseType: t("Response Type"),
        Charts: t("Charts"),
        Patientperprovider: t("Patient per provider"),
        Readingcountlast30days: t("Reading count(last 30 days)"),
        ManualVsAutomatedlast30days: t("Manual Vs Automated (last 30 days)"),
        TOWS: t("TOWS"),
        SurveyResults: t("Survey Results"),
        SurveyName: t("Survey Name"),
        SurveyDescription: t("Survey Description"),
        SurveyResponses: t("Survey Responses"),
        ViewResponses: t("View Responses"),
        Noresponsessinceitwascreatedon: t("No responses since it was created on"),
        ResetFilter: t("Reset Filter"),
        ByCharts: t("By Charts"),
        ByUsers: t("By Users"),
        Pie: t("Pie"),
        Bar: t("Bar"),
        Doughnut: t("Doughnut"),
        chart: t("chart"),
        table: t("table"),
        VerticalBar: t("Vertical Bar"),
        DefaultOrder: t("Default Order"),
        Ascending: t("Ascending"),
        Descending: t("Descending"),
        Wordcloud: t("Wordcloud"),
        CompletedOn: t("Completed On"),
        ViewDetails: t("View Details"),
        Answer: t("Answer"),
        Question: t("Question"),
        basedon: t("based on"),
        Nosurveystodisplay: t("No surveys to display"),
        Textsintable: t("Texts in table"),
        TherearenoresultsyetSystemUser: t("There are no results yet System User"),
        NewUserCreated: t("New User Created"),
        RegisterNewUser: t("Register New User"),
        Sort: t("Sort"),
        Code: t("Code"),
        Contactemail: t("Contact email"),
        Type: t("Type"),
        search: t("search"),
        Registernewuser: t("Register new user"),
        Pulse: t("Pulse"),
        Oxygensaturation: t("Oxygen Saturation."),
        minvalue: t("min value"),
        BloodPressureDiastolic: t("Blood Pressure Diastolic"),
        maxvalue: t("max value"),
        ApplyToUsers: t("Apply To Users"),
        inactive: t("inactive"),
        Active: t("Active"),
        UserDefaults: t("User Defaults"),
        BloodPressureSystolic: t("Blood Pressure Systolic"),
        Deactivated: t("Deactivated"),
        GlobalDefaults: t("Global Defaults"),
        updatingvalues: t("updating values"),
        Success: t("Success"),
        Subject: t("Subject"),
        Thresholdsvaluesupdated: t("Thresholds values updated"),
        Attachment: t("Attachment"),
        Pleasewait: t("Please wait"),
        CreateNotifications: t("Create Notifications"),
        Goback: t("Go back"),
        NotificationForm: t("Notification Form"),
        Sendto: t("Send to"),
        Select: t("Select"),
        Message: t("Message"),
        NotificationHeader: t("Notification Header"),
        TypeNotification: t("Type Notification"),
        SurveyLink: t("Survey Link"),
        SelectSurveyLink: t("Select Survey Link"),
        Attachfile: t("Attach file"),
        RequireResponse: t("Require Response"),
        Frequency: t("Frequency"),
        SendImmediately: t("Send Immediately"),
        Delay: t("Delay"),
        Schedule: t("Schedule"),
        Submit: t("Submit"),
        YesNo: t("Yes-No"),
        unavailable: t("unavailable"),
        Accept: t("Accept"),
        Pleasefilluptheformmarkwith: t("Please fill up the form mark with"),
        Repeat: t("Repeat"),
        For: t("For"),
        Every: t("Every"),
        Sendthisnotificationafterr: t("Send this notification after"),
        Enter: t("Enter"),
        Interval: t("Interval"),
        Daily: t("Daily"),
        Weekly: t("Weekly"),
        EndDate: t("End Date"),
        ShowSchedules: t("Show Schedules"),
        Monthly: t("Monthly"),
        RecurEvery: t("Recur Every"),
        Hourly: t("Hourly"),
        days: t("day(s)"),
        cancel: t("cancel"),
        SchedulesHistory: t("Schedules History"),
        pending: t("pending"),
        Read: t("Read"),
        sentandunread: t("sent and unread"),
        title: t("title"),
        description: t("description"),
        date: t("Date"),
        Nopendingschedulestodisplay: t("No pending schedules to display"),
        status: t("status"),
        MySurveys: t("My Surveys"),
        Surveydescription: t("Survey description"),
        UnderReview: t("Under Review"),
        Draft: t("Draft"),
        Rejected: t("Rejected"),
        SurveyNamecannotempty: t("Survey Name cannot be empty"),
        Approved: t("Approved"),
        CreateSurvey: t("Create Survey"),
        Areyousureyoudeletethissurvey: t("Are you sure you want to delete this survey?"),
        PreviewNewTab: t("Preview in a New Tab"),
        DeletingSurvey: t("Deleting Survey"),
        TestNew: t("Test New"),
        SubmitforReview: t("Submit for Review"),
        Doyouwanttocreateacopysurvey: t("Do you want to create a copy of this survey?"),
        Saveasdraft: t("Save as draft"),
        Note: t("Note"),
        CopySurvey: t("Copy Survey"),
        SurveySubmissionUnderReview: t("Survey Submission Under Review. We are currently reviewing your survey."),
        Delete: t("Delete"),
        Download: t("Download"),
        CreateCopy: t("Create Copy"),
        Preview: t("Preview"),
        Somethingwentwrong: t("Something went wrong. Please try again."),
        AddSurvey: t("Add Survey"),
        CreateGroup: t("Create Group"),
        Groups: t("Groups"),
        GroupName: t("Group Name"),
        GroupDescription: t("Group Description"),
        Usersnotaddedtothisgroup: t("Users not added to this group"),
        SelectAll: t("Select All"),
        Remove: t("Remove"),
        Groupupdatedsuccessfully: t("Group updated successfully."),
        GroupNamecannotbeempty: t("Group Name cannot be empty."),
        DeletingGroup: t("Deleting Group"),
        selected: t("selected"),
        DeletedSuccessfully: t("Deleted Successfully."),
        Areyousureyouwanttodeletegroup: t("Are you sure you want to delete this group?"),
        Showinvisibleelements: t("Show invisible elements"),
        complete: t("complete"),
        Thankyouforcompletingthesurvey: t("Thank you for completing the survey"),
        PreviewSurveyAgain: t("Preview Survey Again"),
        Selectdevicetype: t("Select device type"),
        Themes: t("Themes"),
        ThemeSetting: t("theme setting"),
        Actions: t("Actions"),
        MenuProfile: t("menu\nProfile"),
        Roles: t("Roles"),
        Gender: t("Gender"),
        Height: t("Height"),
        HasRespondedToSurveys: t("has responded to"),
        Birthdate: t("Birthdate"),
        PhoneNumber: t("Phone Number"),
        Profile: t("Profile"),
        ProviderCode: t("Provider Code"),
        NotificationResponses: t("Notification Reponses"),
        SessionTimedOut: t("Uh-oh! Your session has timed out"),
        TookTooLong: t("It seems you took a bit too long."),
        RefreshWarning: t("Refresh the page to continue working or you will be logged out in seconds."),
        DisplayingReadingsFor: t("Displaying Readings for"),
        MeasurementType: t("Measurement Type"),
        IsManual: t("Is Manual"),
        DeviceModel: t("Device Model"),
        UpdateUser: t("Update User"),
        FirstName: t("First Name"),
        LastName: t("Last Name"),
        DateOfBirth: t("Date of Birth"),
        Sex: t("Sex"),
        Male: t("Male"),
        Female: t("Female"),
        NotProvided: t("Not Provided"),
        Deactivate: t("Deactivate"),
        ConfirmDeactivateUser: t("Are you sure you want to deactivate the user?"),
        UserUpdated: t("User has been updated successfully."),
        ScheduleResponses: t("Schedule Responses"),
        Response: t("response"),
        NoResponses: t("No responses to display"),
        ScheduleName: t("Schedule Name"),
        RowsPerPage: t("Rows per page"),
        ContactUsEmail: t("Please contact us at"),
        LoggedInAsAdmin: t("Logged in as Admin"),
        ThresholdBreaches: t("Threshold breaches"),
        ThresholdError: t("You have one or more threshold min value greater than max value"),
        AddMeasurements: t("Please add your measurements"),
        ScheduleNotification: t("Schedule Notification"),
        Email: t("Email"),
        perprovider: t("per provider"),
        Readings: t("Readings"),
        Days: t("Days"),
        per: t("per"),
        Registernewprovider: t("Register New Provider"),
        details: t("Details"),
        Activated: t("Activated"),
        TenantId: t("Tenant Id"),
        DaysInFirstPeriod: t("Days In First Period"),
        DaysInSecondPeriod: t("Days In Second Period"),
        DaysInThirdPeriod: t("Days In Third Period"),
        ReadingEntryTypes: t("Reading Entry Types"),
        MedlineCustomerNumber: t("Medline Customer Number"),
        BillTo: t("Bill To"),
        ContractNumber: t("Contract Number"),
        PatientBillingRate: t("Patient Billing Rate"),
        RecheckBreachedNotification: t("Recheck Breached Notification"),
        SelectDashboardItems: t("Select Dashboard Items"),
        SelectOne: ("Select One"),
        Emailalreadyexists: t("Email already exists"),
        Loading: t("Loading"),
        User: t("User"),
        Create: t("Create"),
        New: t("New"),
        Add: t("Add"),
        Deleting: t("Deleting"),
        Deleteallpatientstodeletethisgroup: t("Delete all patients to delete this group"),
        NoGroupstodisplay: t("No Groups to display"),
        Yes: t("Yes"),
        rows: t("rows"),
        value: t("value"),
        Showdetail: t("Show detail"),
        EnterStartTime: t("Enter Start Time"),
        time: t("Time"),
        EnterEndTime: t("Enter End Time"),
        NoCompletedSchedulestodisplay: t("No Completed Schedules to display"),
        NoReadSchedulestodisplay: t("No Read Schedules to display"),
        Areyousureyouwanttodeletethisschedulednotification: t("Are you sure you want to delete this scheduled notification?"),
        DeletingScheduledNotification: t("Deleting a Scheduled Notification"),
        Selectallprovidersthatapply: t("Select all providers that apply"),
        Approve: t("Approve"),
        Reject: t("Reject"),
        AddComment: t("Add Comment"),
        Pleaseaddcommentbeforerejecting: t("Please add comment before rejecting"),
        Latest: t("Latest"),
        Measurement: t("Measurement"),
        Device: t("Device"),
        Provider: t("Provider"),
        Manual: t("Manual"),
        Responsessinceitwascreatedon: t("responses since it was created on"),
        displayLabel: displayLabel(),
        widgetItemName: widgetItemName,
        pieChartVitalName: pieChartVitalName
    };
};